import { IconType } from "react-icons";
import styled from "styled-components";
import { useRef } from "react";

const defColor = "#b3b3b3";

const Container = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${defColor};
    padding: 6px;
    justify-content: space-between;
`;

const StyledInput = styled.input`
    border: 0;
    width: 85%;

    &:focus {
        outline: none;
    }
`;

export interface InputIconProps {
    icon?: IconType;
    type?: string;
    placeholder?: string;
    value: any;
    onChange: (e: any) => void;
    autoComplete?: string;
    style?: React.CSSProperties;
    onIconClick?: Function;
    autofocus?: boolean;
    inputRef?: React.RefObject<HTMLInputElement>;
    handleFocus?: React.FocusEventHandler<HTMLInputElement>;
}

const InputIcon: React.FC<InputIconProps> = ({
    icon: Icon,
    type = "text",
    value,
    onChange,
    placeholder,
    style,
    onIconClick,
    autofocus,
    inputRef,
    handleFocus
}) => {
    
    return (
        <Container style={style}>
            {Icon && (
                <Icon
                    style={{
                        width: "10%",
                        color: `${defColor}`,
                        cursor: `${onIconClick ? "pointer" : undefined}`,
                    }}
                    onClick={() => (onIconClick ? onIconClick() : null)}
                />
            )}
            <StyledInput
                placeholder={placeholder}
                type={type}
                value={value}
                onChange={onChange}
                autoFocus={autofocus}
                ref={ inputRef }
                onBlur={handleFocus}
                onFocus={handleFocus}
            />
        </Container>
    );
};

export default InputIcon;
